(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDirectory = (directory) => {
      if (directory.dataset.brandDirectoryReady === 'true') return;

      const tools = directory.querySelector('[data-brand-tools]');
      const search = directory.querySelector('[data-brand-search]');
      const clear = directory.querySelector('[data-brand-clear]');
      const buttons = Array.from(directory.querySelectorAll('[data-brand-letter]'));
      const backLinks = Array.from(directory.querySelectorAll('.brand-directory__back'));
      const groups = Array.from(directory.querySelectorAll('[data-brand-group]'));
      const status = directory.querySelector('[role="status"]');
      const noResults = directory.querySelector('[data-brand-no-results]');
      const statusTemplate = directory.dataset.statusTemplate;
      const noResultsText = directory.dataset.noResults;
      let activeLetter = 'all';

      if (!tools || !search || !clear || !status || !noResults) return;
      directory.dataset.brandDirectoryReady = 'true';
      tools.hidden = false;

      const update = () => {
        const query = search.value.trim().toLocaleLowerCase();
        let visibleCount = 0;

        groups.forEach((group) => {
          const letterMatches = activeLetter === 'all' || group.dataset.brandGroup === activeLetter;
          let groupCount = 0;

          group.querySelectorAll('[data-brand-item]').forEach((item) => {
            const name = item.querySelector('a')?.textContent?.trim().toLocaleLowerCase() || '';
            const isVisible = letterMatches && (!query || name.includes(query));
            item.hidden = !isVisible;
            if (isVisible) groupCount += 1;
          });

          group.hidden = groupCount === 0;
          visibleCount += groupCount;
        });

        buttons.forEach((button) => {
          const isActive = button.dataset.brandLetter === activeLetter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        clear.hidden = query.length === 0;
        noResults.hidden = visibleCount !== 0;
        status.textContent = visibleCount === 0
          ? noResultsText
          : statusTemplate.replace('__VISIBLE__', String(visibleCount));
      };

      search.addEventListener('input', () => {
        activeLetter = 'all';
        update();
      });

      clear.addEventListener('click', () => {
        search.value = '';
        activeLetter = 'all';
        update();
        search.focus();
      });

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeLetter = button.dataset.brandLetter;
          update();
        });
      });

      backLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = directory.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          window.history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      update();
    };

    document.querySelectorAll('[data-brand-directory]').forEach(initializeDirectory);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('[data-brand-directory]')) initializeDirectory(event.target);
      event.target.querySelectorAll('[data-brand-directory]').forEach(initializeDirectory);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDirectory = (directory) => {
      if (directory.dataset.categoryDirectoryReady === 'true') return;

      const tools = directory.querySelector('[data-category-tools]');
      const search = directory.querySelector('[data-category-search]');
      const clear = directory.querySelector('[data-category-clear]');
      const buttons = Array.from(directory.querySelectorAll('[data-category-letter]'));
      const backLinks = Array.from(directory.querySelectorAll('.category-directory__back'));
      const groups = Array.from(directory.querySelectorAll('[data-category-group]'));
      const items = Array.from(directory.querySelectorAll('[data-category-item]'));
      const status = directory.querySelector('[role="status"]');
      const noResults = directory.querySelector('[data-category-no-results]');
      const statusTemplate = directory.dataset.statusTemplate;
      const noResultsText = directory.dataset.noResults;
      let activeLetter = 'all';

      if (!tools || !search || !clear || !status || !noResults) return;

      directory.dataset.categoryDirectoryReady = 'true';
      tools.hidden = false;

      const update = () => {
        const query = search.value.trim().toLocaleLowerCase();
        let visibleCount = 0;

        groups.forEach((group) => {
          const letterMatches = activeLetter === 'all' || group.dataset.categoryGroup === activeLetter;
          let groupCount = 0;

          group.querySelectorAll('[data-category-item]').forEach((item) => {
            const queryMatches = !query || item.dataset.categoryName.includes(query);
            const isVisible = letterMatches && queryMatches;
            item.hidden = !isVisible;
            if (isVisible) groupCount += 1;
          });

          group.hidden = groupCount === 0;
          visibleCount += groupCount;
        });

        buttons.forEach((button) => {
          const isActive = button.dataset.categoryLetter === activeLetter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        clear.hidden = query.length === 0;
        noResults.hidden = visibleCount !== 0;
        status.textContent = visibleCount === 0
          ? noResultsText
          : statusTemplate.replace('__VISIBLE__', String(visibleCount));
      };

      search.addEventListener('input', () => {
        activeLetter = 'all';
        update();
      });

      clear.addEventListener('click', () => {
        search.value = '';
        activeLetter = 'all';
        update();
        search.focus();
      });

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeLetter = button.dataset.categoryLetter;
          update();
        });
      });

      backLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.getAttribute('href'));
          if (!target) return;

          event.preventDefault();
          event.stopPropagation();
          target.focus({ preventScroll: true });
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          window.history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      if (items.length > 0) update();
    };

    document.querySelectorAll('[data-category-directory]').forEach(initializeDirectory);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('[data-category-directory]')) {
        initializeDirectory(event.target);
      }
      event.target.querySelectorAll('[data-category-directory]').forEach(initializeDirectory);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us"]) return;
  try {
    
(function () {
  function initContact(section) {
    if (section.dataset.contactReady) return;
    section.dataset.contactReady = 'true';
    var feedback = section.querySelector('[data-contact-feedback]');
    if (feedback) feedback.focus();
  }
  document.querySelectorAll('[data-netrition-contact]').forEach(initContact);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-netrition-contact]').forEach(initContact);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
